import React, { useState,useEffect } from "react";
import { FiUpload } from "react-icons/fi";
import { toBase64,replaceType,dataURLtoFile } from "../../util/Imagem";
import { useParams,useHistory } from "react-router-dom";
import Main from "../../components/template/Main";
import Compressor from 'compressorjs';
import foto from '../../assets/imgs/foto.png';
import { post,get,put } from "../../store/config/register";
import { toast } from "react-toastify";

import './TarefaFoto.css'

const initialState ={
    tarefa: {
      id: 0,
      idAtividade: 0,
      idTarefa: 0,
      titulo: '',
      descricao: '',
      foto:''
    }
  }

let type ='';

const headerProps = {
    icon: "file",
    title: "Foto",
    subtitle: "Cadastro"
}

export default function TarefaFoto() {
    const {id, idTarefa,idFoto} = useParams();
    const [tarefaFoto,setTarefaFoto] = useState(initialState.tarefa);
    const [avatarUrl, setAvatarUrl] = useState(null);
    const [imageAvatar, setImageAvatar] = useState(null);
    const history = useHistory();

    function  updateField( event){
        const tare ={...tarefaFoto}
        tare[event.target.name] = event.target.value
        setTarefaFoto(tare);
    }

      useEffect(()=> {
            setTarefaFoto({...tarefaFoto, idAtividade: parseInt(id),idTarefa:parseInt(idTarefa)});
            if(idFoto !== undefined){
                buscaFotos(idFoto);
            }
        },[]);


        async function buscaFotos(IdFoto) {
            const foto = await get(`/FotoAtividade/v1/Atividade?IdAtividade=${id}&idTarefa=${idTarefa}&id=${IdFoto}`) 
            console.log(foto);
            if(foto !== undefined){
                setTarefaFoto(foto)
                if(foto.foto !== null){
                    console.log(foto.foto)
                    const image = dataURLtoFile(`data:png;base64,${foto.foto}`,'teste.png')
                    setAvatarUrl(URL.createObjectURL(image));
                   // setImageAvatar(image);
                }
            }
        }
        async function Salvar(){
                if(Validar()){
                    if(idFoto === undefined){
                        const res =  await post('/FotoAtividade/v1',tarefaFoto);
                    }else {
                        const res =  await put(`/FotoAtividade/v1/${idFoto}`,tarefaFoto);
                    }
                   
                    toast.success('arquivo anexado com sucesso.')
                    history.goBack()
                }
           
            }
        
            function Validar(){
                if(tarefaFoto.titulo === ''){
                    toast.warning('Escreva um título para a foto em anexo');
                    return false;
                }
        
                if(tarefaFoto.descricao === ''){
                    toast.warning('Escreva uma descrição para a foto em anexo');
                    return false;
                }
        
                if(tarefaFoto.documento === ''){
                    toast.warning('Anexe uma foto para salvar');
                    return false;
                }
        
                return true;
            }

    async function handleFile(e){
            if(e.target.files[0]){
              const image = e.target.files[0];
    
              
              type='';
              if(image.type === 'image/jpeg' || image.type === 'image/png'){
    
                new Compressor( image, {
                  quality: 0.6, // 0.6 can also be used, but its not recommended to go below.
                  success: async( compressedResult) => {
                    // compressedResult has the compressed file.
                    // Use the compressed file to upload the images to your server.        
                    type=compressedResult.type;
                    setImageAvatar(compressedResult);
                    setAvatarUrl(URL.createObjectURL(compressedResult))
                    let base64=await toBase64(compressedResult);          
                    if (type ==='image/jpeg'){
                        setTarefaFoto({...tarefaFoto,foto: base64.replace('data:image/jpeg;base64,','')});
                    }else{
                        setTarefaFoto({...tarefaFoto, foto: base64.replace('data:image/png;base64,','')});
                    }

                    setImageAvatar(replaceType(base64))
                  },
                });
                
               
    
              }else{
                alert('Envie uma imagem do tipo PNG ou JPEG');
                setImageAvatar(null);
                setAvatarUrl(null);
                return null;
              }
        
            }
        
          }


    function renderForm(){
        return (
            <div className="form">
                <div className="email">
                    <div className="form-group">
                    <label>Título:</label>
                    <input type="text" name="titulo" 
                    placeholder="Titulo"
                        className="form-control" value={tarefaFoto.titulo} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                <div className="email">
                    <div className="form-group">
                    <label>Descrição:</label>
                    <input type="text" name="descricao" placeholder="Descrição"
                        className="form-control" value={tarefaFoto.descricao} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                <label>Foto:</label>
                <div className="img_foto">
                    <label className="label-avatar">
                            <span>
                                <FiUpload color="#FFF" size={25} />
                            </span>

                            <input type="file" accept="image/*" onChange={handleFile}  /><br/>
                            { avatarUrl === null ? 
                                <img src={tarefaFoto.foto} width="210" height="240" alt="Foto de perfil do usuario" />
                                :
                                <img src={avatarUrl} width="210" height="240" alt="Foto de perfil do usuario" />
                            }
                    </label>
                </div>
            
                    <div id="botao">
                    <button  className="btn btn-primary ml-2" onClick={ async e => Salvar()}>
                        Salvar
                    </button>
                    <button className="btn btn-secondary ml-2" onClick={e =>history.goBack()}>
                        Cancelar
                    </button>
                </div>       
            </div>
        );
    }

    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}